import "./HomeNotice.scoped.scss"
import NoticeItem from "./NoticeItem";

function HomeNotice() {
  return (
    <div className="notice-list">
      <NoticeItem />
    </div>
  );
}

export default HomeNotice;